export class GetBusinessEntityStatusById {
  static readonly type = '[Business Entity Id] Get';

  constructor(
    public businessEntityId: string
  ) {}
}
